module.exports = __webpack_public_path__ + "img/commemorate.75548a89.jpg";